var Attendee = (function($) {
    
    function Attendee(itemId) {
        if (!itemId) {
            throw 'An Item ID (Seat Reserve ID) is required.';
        }

        this._itemId = itemId; 
        this._attendee = {};
    }

    var _fields = [
                    'firstName', 
                    'lastName',
                    'email',
                    'phoneNumber',
                    'dobDay',
                    'dobMonth',
                    'dobYear'
                    ];

    Attendee.prototype.getItemId = function() {
        return this._itemId;
    };

    Attendee.prototype.setData = function(data) {
        this._attendee = pick(data, _fields);
    };

    Attendee.prototype.getData = function() {
        return $.extend({}, this._attendee);
    };

    Attendee.prototype.getField = function(key) {
        return this._attendee[key];
    };

    function pick(sourceObject, keys) {
        var pickObject = {};

        keys.forEach(function(key) {
            pickObject[key] = sourceObject[key];
        });

        return pickObject;
    }

    return Attendee;
})(window.jQuery);

